import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { mdlTablePagination } from "../../models/ui-models/TablePagination";
import { PageHeaderSection } from "../../components/common/PageHeadSection";
import { Button, Col, Flex, Form, message, Row, Skeleton } from "antd";
import _ from "lodash";
import { SFModal } from "../../components/elements/SFModal";
import { mdlOffer } from "../../models/domain/Offer";
import { OfferService } from "../../services/OfferService";
import { mdlStopFreeSaleMessageRequest } from "../../models/service-models/stop-free-sale/StopFreeSaleMessageRequest";
import { OfferTable } from "../../components/offer/OfferTable";
import { enmOfferAnswerType } from "../../models/enums/OfferAnswerType";
import { OfferDetail } from "../../components/offer/OfferDetail";
import { mdlOfferHotelTypeListForSejourRequest } from "../../models/service-models/offer/OfferHotelTypeListForSejourRequest";
import { mdlOfferDetailRequest } from "../../models/service-models/offer/OfferDetailRequest";
import { mdlOfferHistory } from "../../models/domain/OfferHistory";
import { mdlOfferHistoryRequest } from "../../models/service-models/offer/OfferHistoryRequest";
import { mdlStopFreeSaleMessage } from "../../models/domain/StopFreeSaleMessage";
import { StopFreeSaleService } from "../../services/StopFreeSaleService";
import { HotelSelect } from "../../components/common/HotelSelect";
import Input from "antd/es/input/Input";
import TextArea from "antd/es/input/TextArea";
import { toast } from "react-toastify";
import { ObjectHelper } from "../../utils/ObjectHelper";
import { nanoid } from "@reduxjs/toolkit";
import { mdlStopFreeSaleMessageUpdateRequest } from "../../models/service-models/stop-free-sale/StopFreeSaleMessageUpdateRequest";


export const StopFreeSaleMessage = () => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [request, setRequest] = useState<mdlStopFreeSaleMessageRequest>();
    const [selectedHotel, setSelectedHotel] = useState<string>();
    useEffect(() => {
    }, []);

    const getRoomMessage = useMutation({
        mutationFn: (data: mdlStopFreeSaleMessageRequest) => {
            return StopFreeSaleService.GetMessage(data)
        }
    })

    const handleHotelSelect = async (hotelId: string) => {
        form.setFieldsValue({ hotelId: hotelId });
        setSelectedHotel(hotelId);
        const result = await getRoomMessage.mutateAsync({ ...request, hotelId: hotelId })
        if (result && result.body && result.body && result.body.data )
        {    
            form.setFieldsValue({stopMessage : result.body?.data?.stopMessage});
            form.setFieldsValue({freeMessage : result.body?.data?.freeMessage});
        }else{
            form.setFieldsValue({stopMessage : null});
            form.setFieldsValue({freeMessage : null});
        }
    }

    const { mutateAsync: saveStopFreeSaleMessage, isLoading: mutateLoading, data: mutateData } = useMutation(
        (data: mdlStopFreeSaleMessageRequest) => StopFreeSaleService.UpdateMessage(data as mdlStopFreeSaleMessageRequest),
        {
            onMutate(variables) {
            },
            onError: error => {
                console.log(error);
            },
            onSuccess(data, variables, context) {
                if (data.header && data.header.success) {
                    toast.success(t("common.success"));
                }
                else {
                    toast.error(ObjectHelper.getErrorMessage(data.header.messages));
                }
            }
        }
    );


    return (
        <>
            <div className="nk-content ">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <PageHeaderSection
                                pageTitle={t("stopFreeSale.stopFreeSaleMessages")}
                            />
                            <div className="nk-block">
                                <div className="card card-bordered h-100">
                                    <div className="card-inner">

                                        <Form
                                            form={form}
                                            key={nanoid()}
                                            name="agency-form"
                                            layout="vertical"
                                            onFinish={async (values) => await saveStopFreeSaleMessage(values)}
                                            autoComplete="off"
                                        >

                                            <Col span={6}>
                                                <Form.Item<mdlStopFreeSaleMessageUpdateRequest>
                                                    label={t("common.chooseHotel")}
                                                    name="hotelId"
                                                    rules={[{ required: true, message: t("common.required") }]}
                                                >
                                                    <HotelSelect onChange={handleHotelSelect} />
                                                </Form.Item>
                                            </Col>
                                            {
                                                selectedHotel &&
                                                <>
                                                    <Row gutter={24}>

                                                        <Col span={24}>
                                                            <Form.Item<mdlStopFreeSaleMessageUpdateRequest>
                                                                label={t("stopFreeSale.stopSaleMessage")}
                                                                name={["stopMessage"]}
                                                                rules={[{ required: true, message: t("common.required") }]}
                                                            >
                                                                <TextArea style={{height:180}} />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span={24}>
                                                            <Form.Item<mdlStopFreeSaleMessageUpdateRequest>
                                                                label={t("stopFreeSale.freeSaleMessage")}
                                                                name={["freeMessage"]}
                                                                rules={[{ required: true, message: t("common.required") }]}
                                                            >
                                                                <TextArea style={{height:180}} />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                    <Form.Item>
                                                        <Flex align={"center"} justify="flex-end">
                                                            <Button type="primary" htmlType="submit">{t("common.save")}</Button>
                                                        </Flex>

                                                    </Form.Item>
                                                </>
                                            }
                                        </Form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>


    );
};
